import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { getVisitsSchema } from '../visits/getVisits';
import { getQuestionSchema } from './getQuestions';
export const getQSTTransactionMasterSchema = baseObjectSchema.extend({
  qstQuestionID: z.string(),
  qstQuestion: getQuestionSchema.optional(),
  visitID: z.string(),
  visit: getVisitsSchema.optional(),
  insertDate: z.string(),
  visitLoginID: z.string(),
});
export type GetTransactionMasterResponse = z.infer<typeof getQSTTransactionMasterSchema>;
